import { render, staticRenderFns } from "./RoomCreateView.vue?vue&type=template&id=2f3c5b4e&scoped=true"
import script from "./RoomCreateView.vue?vue&type=script&lang=js"
export * from "./RoomCreateView.vue?vue&type=script&lang=js"
import style0 from "./RoomCreateView.vue?vue&type=style&index=0&id=2f3c5b4e&prod&scoped=true&lang=css"
import style1 from "./RoomCreateView.vue?vue&type=style&index=1&id=2f3c5b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c5b4e",
  null
  
)

export default component.exports